var _defs, _rect, _path, _path2, _g, _g2, _g3, _g4, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTradingInfra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 560",
    width: 1000,
    height: 560,
    role: "img",
    "aria-label": "Real-time trading platform pipeline from market data to execution",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tiBg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eef0f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tiFill",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6c5ce7",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6c5ce7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tiNode",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4f3fd"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "tiArrow",
    viewBox: "0 0 10 10",
    refX: 9,
    refY: 5,
    markerWidth: 7,
    markerHeight: 7,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L10 5 L0 10 z",
    fill: "#6c5ce7"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 560,
    fill: "url(#tiBg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 300 C 170 292, 240 250, 330 244 C 420 238, 470 208, 560 176 C 650 144, 720 152, 810 116 C 880 88, 910 98, 940 78 L940 320 L60 320 Z",
    fill: "url(#tiFill)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 300 C 170 292, 240 250, 330 244 C 420 238, 470 208, 560 176 C 650 144, 720 152, 810 116 C 880 88, 910 98, 940 78",
    fill: "none",
    stroke: "#6c5ce7",
    strokeWidth: 2.5,
    strokeOpacity: 0.55
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#0b0b0c",
    strokeOpacity: 0.06,
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 120,
    x2: 940,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 200,
    x2: 940,
    y2: 200
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 280,
    x2: 940,
    y2: 280
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 336,
    width: 150,
    height: 72,
    rx: 12,
    fill: "url(#tiNode)",
    stroke: "#6c5ce7",
    strokeOpacity: 0.45
  }), /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 366,
    fontSize: 16,
    fontWeight: 600,
    fill: "#1d1d1f"
  }, "Market data"), /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 388,
    fontSize: 13,
    fill: "#6e6e73"
  }, "multi-provider")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 336,
    width: 150,
    height: 72,
    rx: 12,
    fill: "url(#tiNode)",
    stroke: "#6c5ce7",
    strokeOpacity: 0.45
  }), /*#__PURE__*/React.createElement("text", {
    x: 258,
    y: 366,
    fontSize: 16,
    fontWeight: 600,
    fill: "#1d1d1f"
  }, "Ingestion"), /*#__PURE__*/React.createElement("text", {
    x: 258,
    y: 388,
    fontSize: 13,
    fill: "#6e6e73"
  }, "clean \xB7 validate")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 336,
    width: 150,
    height: 72,
    rx: 12,
    fill: "url(#tiNode)",
    stroke: "#6c5ce7",
    strokeOpacity: 0.45
  }), /*#__PURE__*/React.createElement("text", {
    x: 436,
    y: 366,
    fontSize: 16,
    fontWeight: 600,
    fill: "#1d1d1f"
  }, "Signal engine"), /*#__PURE__*/React.createElement("text", {
    x: 436,
    y: 388,
    fontSize: 13,
    fill: "#6e6e73"
  }, "multi-factor \xB7 ML")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 594,
    y: 336,
    width: 150,
    height: 72,
    rx: 12,
    fill: "url(#tiNode)",
    stroke: "#6c5ce7",
    strokeOpacity: 0.45
  }), /*#__PURE__*/React.createElement("text", {
    x: 614,
    y: 366,
    fontSize: 16,
    fontWeight: 600,
    fill: "#1d1d1f"
  }, "Agentic AI"), /*#__PURE__*/React.createElement("text", {
    x: 614,
    y: 388,
    fontSize: 13,
    fill: "#6e6e73"
  }, "sentiment \xB7 support")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 772,
    y: 336,
    width: 168,
    height: 72,
    rx: 12,
    fill: "#6c5ce7",
    fillOpacity: 0.16,
    stroke: "#6c5ce7",
    strokeOpacity: 0.6
  }), /*#__PURE__*/React.createElement("text", {
    x: 792,
    y: 366,
    fontSize: 16,
    fontWeight: 600,
    fill: "#1d1d1f"
  }, "Risk &amp; execution"), /*#__PURE__*/React.createElement("text", {
    x: 792,
    y: 388,
    fontSize: 13,
    fill: "#6e6e73"
  }, "single checked path")))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    stroke: "#6c5ce7",
    strokeWidth: 2,
    fill: "none",
    markerEnd: "url(#tiArrow)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 210,
    y1: 372,
    x2: 230,
    y2: 372
  }), /*#__PURE__*/React.createElement("line", {
    x1: 388,
    y1: 372,
    x2: 408,
    y2: 372
  }), /*#__PURE__*/React.createElement("line", {
    x1: 566,
    y1: 372,
    x2: 586,
    y2: 372
  }), /*#__PURE__*/React.createElement("line", {
    x1: 744,
    y1: 372,
    x2: 764,
    y2: 372
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 462,
    x2: 940,
    y2: 462,
    stroke: "#0b0b0c",
    strokeOpacity: 0.15,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 484,
    fontSize: 12,
    fill: "#a1a1a6"
  }, "s"), /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 484,
    fontSize: 12,
    fill: "#a1a1a6"
  }, "ms"), /*#__PURE__*/React.createElement("text", {
    x: 930,
    y: 484,
    fontSize: 12,
    fill: "#a1a1a6"
  }, "\xB5s"), /*#__PURE__*/React.createElement("circle", {
    cx: 516,
    cy: 462,
    r: 6,
    fill: "#6c5ce7"
  }), /*#__PURE__*/React.createElement("text", {
    x: 534,
    y: 467,
    fontSize: 15,
    fontWeight: 600,
    fill: "#6c5ce7"
  }, "millisecond regime"), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 440,
    fontSize: 13,
    fontWeight: 700,
    letterSpacing: 1.2,
    fill: "#6e6e73"
  }, "SIGNAL LATENCY"), /*#__PURE__*/React.createElement("text", {
    x: 700,
    y: 440,
    fontSize: 13,
    fill: "#6e6e73"
  }, "caching \xB7 async processing"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 512,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontSize: 27,
    fontWeight: 700,
    letterSpacing: -0.5,
    fill: "#1d1d1f"
  }, "Trading Interface &amp; Infrastructure")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 540,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontSize: 17,
    fontWeight: 500,
    fill: "#6e6e73"
  }, "Live ingestion to execution, with agentic AI in the decision path")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradingInfra);
export default __webpack_public_path__ + "static/media/trading_infra.136e2cb0ff18658e3e978356364f021e.svg";
export { ForwardRef as ReactComponent };